import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" bonacasa SwissApp ")
const _hoisted_2 = { class: "bg-[var(--code-color)] rounded-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", { class: "align-top w-20 p-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "Siedlung")
], -1)
const _hoisted_4 = { class: "p-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "align-top w-20 p-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "Wohnung")
], -1)
const _hoisted_6 = { class: "p-2" }
const _hoisted_7 = { class: "text-xs text-gray-400 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomePerson20Regular = _resolveComponent("HomePerson20Regular")!
  const _component_ArrowCircleLeft20Regular = _resolveComponent("ArrowCircleLeft20Regular")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_List20Regular = _resolveComponent("List20Regular")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_n_layout_content = _resolveComponent("n-layout-content")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_menu = _resolveComponent("n-menu")!
  const _component_n_drawer_content = _resolveComponent("n-drawer-content")!
  const _component_n_drawer = _resolveComponent("n-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_spin, {
      class: _normalizeClass({ 'bg-black': _ctx.theme == 'dark' }),
      show: _ctx.apiStore.apiFetching
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_layout, {
          embedded: "",
          "content-style": "height: 100vh;"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_layout_content, { class: "bg-transparent h-full select-none" }, {
              default: _withCtx(() => [
                _createVNode(_component_n_space, {
                  class: "p-4",
                  size: 16,
                  vertical: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_card, { size: "small" }, {
                      header: _withCtx(() => [
                        _createVNode(_component_n_space, {
                          align: "center",
                          class: "leading-none"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_button, {
                              color: "#5f9e42",
                              text: "",
                              disabled: 
                    _ctx.router.currentRoute.value.name == 'asset-types'
                      ? true
                      : false
                  ,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_n_icon, { size: "32" }, {
                                  default: _withCtx(() => [
                                    (_ctx.router.currentRoute.value.name == 'asset-types')
                                      ? (_openBlock(), _createBlock(_component_HomePerson20Regular, { key: 0 }))
                                      : (_openBlock(), _createBlock(_component_ArrowCircleLeft20Regular, { key: 1 }))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            _hoisted_1
                          ]),
                          _: 1
                        })
                      ]),
                      "header-extra": _withCtx(() => [
                        _createVNode(_component_n_button, {
                          type: "tertiary",
                          size: "large",
                          quaternary: "",
                          circle: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drawer = true))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_n_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_List20Regular)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component }) => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "show"]),
    _createVNode(_component_n_drawer, {
      show: _ctx.drawer,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.drawer) = $event)),
      "auto-focus": false,
      class: "m-4 rounded-md",
      width: "300",
      to: ".n-element"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_drawer_content, { "body-content-style": "padding: 8px;" }, {
          default: _withCtx(() => [
            _createVNode(_component_n_space, {
              justify: "space-between",
              vertical: "",
              style: {"height":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_menu, {
                  value: _ctx.router.currentRoute.value.path,
                  options: _ctx.menuOptions,
                  indent: 16,
                  "root-indent": 16,
                  class: "text-lg",
                  "onUpdate:value": _ctx.menuUpdateValue
                }, null, 8, ["value", "options", "onUpdate:value"]),
                _createVNode(_component_n_space, {
                  class: "p-2",
                  size: "large",
                  vertical: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("table", null, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_3,
                            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.apartmentData.building_complex.name) + ", " + _toDisplayString(_ctx.apartmentData.building.street), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_5,
                            _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.apartmentData.name), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.nodeEnv?.charAt(0).toUpperCase()) + "." + _toDisplayString(_ctx.APP_VERSION), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}